export enum GlobalDateFormat {
  MONTHNAME_YEAR = "monthYear",
  SHORT = "short",
  LONG = "long",
  LONG_WITH_TIME = "longWithTime",
  LONG_WITH_SECONDS = "longWithSeconds"
}
